import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import { modal } from 'react-redux-modal';
import LoginModalView from '../../Modals/Login';
import FavoriteModal from '../../Modals/Favorites';
import { addUserFavorite, removeUserFavorite } from '../../../actions/favorites';
import TrackedButton from '../TrackedButton';

const propTypes = {
  favorites: PropTypes.arrayOf(PropTypes.number),
  isFetching: PropTypes.bool,
  userName: PropTypes.string,
  feedTitle: PropTypes.string,
  buttonType: PropTypes.string,
  isAuthenticated: PropTypes.bool,
  itemId: PropTypes.number,
  addFavorite: PropTypes.func,
  removeFavorite: PropTypes.func,
};

const defaultProps = {
  favorites: [],
  isFetching: false,
  userName: '',
  feedTitle: '',
  buttonType: 'video-player-action-btn',
  isAuthenticated: '',
  itemId: null,
  addFavorite: () => {},
  removeFavorite: () => {},
};

export class FavoriteButton extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isFaved: false
    };
    this.favFeed = this.favFeed.bind(this);
  }

  favFeed = () => {
    const {
      addFavorite,
      favorites,
      feedTitle,
      isAuthenticated,
      isFetching,
      itemId,
      removeFavorite,
      userName,
    } = this.props;

    if (_.isUndefined(itemId) || isFetching) {
      return null;
    }

    const isFaved = (favorites && favorites.indexOf(itemId) > -1);
    if (isAuthenticated) {
      if (isFaved) {
        removeFavorite(itemId);
      } else {
        addFavorite(itemId);
        modal.add(FavoriteModal, {
          hideTitleBar: true,
          title: '',
          size: 'small',
          username: userName,
          feedTitle,
        });
      }
    } else {
      modal.add(LoginModalView, { title: '', size: 'medium', hideTitleBar: true });
    }

    return null;
  };

  render() {
    const { itemId, favorites, buttonType } = this.props;
    const isFaved = (favorites && favorites.indexOf(itemId) > -1);

    const faved = (isFaved) ? 'is-faved' : '';
    const favedIcon = (isFaved) ? 'icon-Heart_Fill' : 'icon-Heart_Stroke';

    return (
      <div>
        <TrackedButton
          className={`${buttonType} heart ${faved}`}
          data-tip
          data-for="favorites"
          onClick={this.favFeed}
          role="button"
          title="My Fav"
          action="Toggled livecam fav"
        >
          <i className={favedIcon} />
          <span className="label">
            My Fav
          </span>
        </TrackedButton>
        <ReactTooltip
          id="favorites"
          type="light"
          effect="solid"
        >
          {isFaved ? 'Unfavorite' : 'Favorite'} Cam
        </ReactTooltip>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    favorites: state.favorites.user.livecams,
    isFetching: state.favorites.isFetching,
    userName: state.auth.userName,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    removeFavorite: (id) => {
      dispatch(removeUserFavorite(id, 'livecam'));
    },
    addFavorite: (id) => {
      dispatch(addUserFavorite(id, 'livecam'));
    },
  };
};

FavoriteButton.propTypes = propTypes;
FavoriteButton.defaultProps = defaultProps;

export default connect(mapStateToProps, mapDispatchToProps)(FavoriteButton);
